import { HttpClient, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map, of } from "rxjs";
import { catchError, timeout } from "rxjs/operators";
import { APP_BASE_HREF } from "@angular/common";

import { HttpServiceBase, OperationError } from "@indusoft/angular-base-services";

import { RoutesGlossary } from "../../common/glossary/routes-glossary";
import { GetAuthConfigResponse } from "./dtos/auth-config-get-response";
import { GetAasConfigResponse } from "./dtos/aas-config-get-response";
import { GetIdsLsConfigResponse } from "./dtos/ids-ls-config-get-response";
import { AppConfiguration } from "../models/app-configuration";

@Injectable({
    providedIn: 'root'
})

export class ConfigurationHttpService extends HttpServiceBase {
    protected serviceUrl = './assets/';
    private static readonly CONFIG_NAME = "config.json";
    private config: AppConfiguration = null;

    private aasEnabled: boolean = false;

    constructor(http: HttpClient,
        @Inject(APP_BASE_HREF) public baseHref: string) {
        super(http);
    }

    public initConfig(): Promise<any> {
        return new Promise<any>((resolve, reject) => {

            this.getAssetContent(ConfigurationHttpService.CONFIG_NAME)
                .subscribe((data: any) => {

                    if (data instanceof OperationError) {
                        reject();
                        return;
                    }

                    this.config = <AppConfiguration>data;

                    resolve(null);
                });
        });
    }

    public getFullUrl(path: string): string {
        let baseUrl = this.apiUrl || window.location.origin + (this.baseHref || '');

        const cleanBase = baseUrl.replace(/\/+$/, '');

        const cleanPath = (path || '').replace(/^\/+|\/+$/g, '');

        if (!cleanPath) {
            return cleanBase;
        }

        return `${cleanBase}/${cleanPath}`;
    }

    public get apiUrl(): string {
        if (!this.config) {
            return (window.location.origin + this.baseHref).slice(0, -1);
        }

        if (!this.config.apiUrl) {
            return (window.location.origin + this.baseHref).slice(0, -1);
        }

        return (this.config.apiUrl + this.baseHref).slice(0, -1);
    }

    public getAssetContent(assetFileName: string): Observable<any | OperationError> {
        const url = this.serviceUrl + assetFileName;

        return this.http.get<HttpResponse<string>>(url)
            .pipe(
                timeout(10000),
                catchError(this.handleError(
                    "ConfigurationService.getAssetContent",
                    OperationError.Message("Не удалось загрузить файл " + assetFileName)))
            );
    }




    public getAuthConfiguration(): Observable<GetAuthConfigResponse | null> {
        const url = this.getFullUrl(RoutesGlossary.GetAuthConfig)
        return this.http.get<GetAuthConfigResponse>(url).pipe(
            catchError(error => {
                console.error('Failed to get auth config:', error);
                return of(null);
            })
        );
    }

    public getAasConfiguration(): Observable<GetAasConfigResponse | null> {
        const url = this.getFullUrl(RoutesGlossary.GetAasConfig);
        return this.httpGet<GetAasConfigResponse>(url, '')
            .pipe(
                map(response => {
                    if (response instanceof OperationError || !response) {
                        return null;
                    }

                    const config = new GetAasConfigResponse();
                    config.address = response.address;
                    config.enabled = response.enabled;
                    this.aasEnabled = config.enabled;

                    return config;
                })
            );
    }

    public getIdsLsConfiguration(): Observable<GetIdsLsConfigResponse | null> {
        const url = this.getFullUrl(RoutesGlossary.GetIdsLsConfig);
        return this.http.get<GetIdsLsConfigResponse>(url).pipe(
            catchError(error => {
                console.error('Failed to get I-DS/LS configuration:', error);
                return of(null);
            })
        );
    }

    public get isAasEnabled(): boolean {
        return this.aasEnabled;
    }
}